import CloseBGGreySvg from "@/assets/svg/CloseBGGreySvg";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { FC, useState } from "react";
import CreatePostModal from "../CreatePostModal/CreatePostModal";
import PenSvg from "@/assets/svg/PenSvg";
import { styles } from "./stylesNewPostModal";
import CustomToast from "../../CustomToast/CustomToast";

const NewPostModal: FC<any> = ({ open, handleClose }) => {
  const postsVariant = ["Stocks", "Economics", "Personal"];
  const [postVariant, setPostVariant] = useState("");
  const [toast, setToast] = useState<{
    message: string;
    success: boolean;
    link?: { text: string; href: string };
  } | null>(null);
  const handleCloseModal = () => {
    setPostVariant("");
    handleClose();
  };

  return (
    <div style={{ display: !postVariant.length ? "none !important" : "block" }}>
      {toast && (
        <CustomToast
          message={toast.message}
          success={toast.success}
          onClose={() => setToast(null)}
          link={toast.link}
        />
      )}
      <Dialog
        open={open && !postVariant}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: styles.dialogPaper }}
        BackdropProps={{
          sx: styles.dialogBackdrop(Boolean(postVariant.length)),
        }}
      >
        <Box sx={styles.wrapper}>
          <Box sx={styles.penIconWrapper}>
            <PenSvg width={38} height={38} />
            <Box onClick={handleClose} sx={styles.closeButton}>
              <CloseBGGreySvg />
            </Box>
          </Box>

          <Typography variant="subtitle2" component="h2" sx={styles.title}>
            Create New Post
          </Typography>

          <Typography variant="h4" sx={styles.subtitle}>
            What do you want to post about?
          </Typography>

          <Box sx={styles.buttonGroup}>
            {postsVariant.map((item, index) => (
              <Button
                key={index}
                variant="contained"
                sx={styles.postTypeButton}
                onClick={() => setPostVariant(item)}
              >
                {item}
              </Button>
            ))}
          </Box>
        </Box>
      </Dialog>

      <CreatePostModal
        open={Boolean(postVariant)}
        postVariant={postVariant}
        handleClose={handleCloseModal}
        setToast={setToast}
      />
    </div>
  );
};

export default NewPostModal;
